/**
 * Three-state theme toggle: light → dark → system → light.
 *
 * Renders the current state's icon. We deliberately cycle rather than show
 * a dropdown — the keyboard shortcut crowd and the touch crowd both prefer
 * one-click theme flips, and we don't have enough states to justify the
 * extra menu chrome.
 */
import { Moon, Sun, MonitorCog } from 'lucide-react';
import { useTheme } from '@/lib/theme';
import { Button } from '@/components/ui/button';

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();

  function next() {
    if (theme === 'light') setTheme('dark');
    else if (theme === 'dark') setTheme('system');
    else setTheme('light');
  }

  const Icon = theme === 'light' ? Sun : theme === 'dark' ? Moon : MonitorCog;
  const label =
    theme === 'light' ? 'Light theme' : theme === 'dark' ? 'Dark theme' : 'System theme';

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={next}
      className={className}
      aria-label={`${label} (click to cycle)`}
      title={`${label} — click to cycle`}
    >
      <Icon className="h-4 w-4" />
    </Button>
  );
}

export default ThemeToggle;
